/**
 * App configuration - a mix of defaults and detected
 * environment settings.
 */
define('config',[
    'jquery',
    'lib/lodash4',
    'module',
    'defaultConfig',
    'environmentConfig',
    'util/queryParamParser'
], function ($, _, module, defaults, environments, queryParser) {
    'use strict';

    function buildUri(object) {
        var uri = '';
        if (object.protocol && object.hostname) {
            uri += object.protocol + '://';
        }
        if (object.hostname) {
            uri += object.hostname;
        }
        if (object.port && object.hostname) {
            uri += ':' + object.port;
        }
        if (object.path) {
            if (!object.path.match('^/')) {
                uri += '/';
            }
            uri += object.path;
        }

        return uri;
    }

    var config = {};
    var envOveride = queryParser.getParameterValue('env');
    var environment = _.find(environments, function (value, key) {
        if (window.location.hostname.match(key + '$')) {
            return true;
        }
    });

    if (envOveride) {
        environment = environments['local-' + envOveride];
    }

    //Use default values if we're not in a recognized environment
    if (!environment) {
        _.merge(config, defaults, environments[defaults.defaultEnvironment]);
    } else {
        _.merge(config, defaults, environment);
    }

    config.api.uri = buildUri(config.api);
    config.notifications.uri = buildUri(config.notifications);
    config.uploadService.uri = buildUri(config.uploadService);
    config.uploadServicev4.uri = buildUri(config.uploadServicev4);
    config.architect.uri = buildUri(config.architect);
    config.scripter.uri = buildUri(config.scripter);
    config.qualityForms.uri = buildUri(config.qualityForms);
    config.journey.uri = buildUri(config.journey);
    config.appName = 'contact-center-ui';
    config.appVersion = $('head meta[name="app-version"]').attr('content');
    config.embedded = module.config().embedded;

    if (envOveride) {
        config.env = envOveride;
    }

    return config;
});

